<ng-container>
  <div class="row">
    <div class="col-md-11 fieldset">
      <div class="card mt-2 mt-md-0">
        <div class="card-body p-0 pt-3 px-3 m-0">
          <div class="col-md fieldset">
            <div class="row">
              <app-form-group>
                <app-info class="formGroupLabel">
                  <label>{{ vesselPrefix }} vessel name/IMO</label>
                  <div class="tooltipContent">{{ vesselPrefix }} {{ shipLabelTooltip }}</div>
                </app-info>
                <app-search [(ngModel)]="vessel" (ngModelChange)="onVesselChange()"
                          [searchFunction]="searchVessel" [inputFormatter]="vesselNameFormatter"
                          [minCharacters]="3" dataKey="imoCode" id="thirdVessel">
                </app-search>
              </app-form-group>
            </div>
            <div class="row">
              <app-form-group label="{{ vesselPrefix }} vessel IMO">
                  <input [(ngModel)]="formShip.imo" id="eni" maxlength="64" class="form-control" required readonly>
              </app-form-group>
            </div>
            <div class="row">
              <app-form-group label="{{ vesselPrefix }} vessel Name">
                <input [(ngModel)]="formShip.name" id="name" maxlength="64" class="form-control" required readonly>
              </app-form-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-1 fieldset">
      <div>
        <button class="btn">
          <span class="fa fa-trash text-secondary" (click)="notifyParent()"></span>
        </button>
      </div>
    </div>
  </div>
  <br>
</ng-container>
